
import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../state';
import { postResource } from '../../../client/resource';
import { Role } from '../../../../../common/framework/model/Role';
import SwitchField from '../../../fields/SwitchField.vue';
import SelectField from '../../../fields/SelectField.vue';
import PhoneField from '../../../fields/PhoneField.vue';
import TextField from '../../../fields/TextField.vue';
import EmailField from '../../../fields/EmailField.vue';

@Component({
    components: { SwitchField, SelectField, PhoneField, TextField, EmailField, ValidationObserver },
})
export default class AddRole extends Vue {
    readonly resourceType = 'role';

    shared = sharedState;
    local = {
        id: '',
        name: '',
        created: new Date(),
        modified: new Date(),
    };

    clear() {
        this.local.name = '';
    }

    async add() {
        const object: Role = Object.assign(
            {
                id: '',
                created: new Date(),
                modified: new Date(),
            },
            this.local,
        ) as any as Role;
        await postResource(this.resourceType, object);

        this.$router.go(-1);
        this.clear();
    }

    back() {
        this.$router.go(-1);
    }
}
